import React from 'react';
import { Link } from 'react-router-dom';
import { useTheme } from '../contexts/ThemeContext';

export default function Footer() {
  const { settings } = useTheme();

  return (
    <footer className="bg-[var(--color-primary)] text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          <div>
            <img src="/logo.svg" alt="Skaha Sauna Co." className="h-12 mb-4" />
            <p className="text-sm text-gray-300">{settings.footer_text || 'Mobile sauna rentals in Penticton, BC.'}</p>
          </div>
          <div>
            <h4 className="text-sm font-semibold mb-4 uppercase tracking-wider">Quick Links</h4>
            <ul className="space-y-2 text-sm text-gray-300">
              <li><Link to="/about" className="hover:text-white">About</Link></li>
              <li><Link to="/services" className="hover:text-white">Services</Link></li>
              <li><Link to="/gallery" className="hover:text-white">Gallery</Link></li>
              <li><Link to="/contact" className="hover:text-white">Contact</Link></li>
              <li><Link to="/book" className="hover:text-white">Book Now</Link></li>
            </ul>
          </div>
          <div>
            <h4 className="text-sm font-semibold mb-4 uppercase tracking-wider">Contact</h4>
            <ul className="space-y-2 text-sm text-gray-300">
              {settings.contact_email && <li>{settings.contact_email}</li>}
              {settings.contact_phone && <li>{settings.contact_phone}</li>}
              {settings.contact_address && <li>{settings.contact_address}</li>}
              {settings.instagram_url && (
                <li><a href={settings.instagram_url} target="_blank" rel="noopener noreferrer" className="hover:text-white">Instagram</a></li>
              )}
            </ul>
          </div>
        </div>
        <div className="mt-8 pt-8 border-t border-white/20 text-center text-sm text-gray-400">
          &copy; {new Date().getFullYear()} Skaha Sauna Co. All rights reserved.
        </div>
      </div>
    </footer>
  );
}
